import { dataFetcher } from 'core/services/requestHandler';   

const getIssuesByProperty = async (data = {}, config = {}) => {
  return dataFetcher('issues/getIssuesByProperty', data, {...config});
};

const getIssueById = async (data = {}, config = {}) => {
  return dataFetcher('issues/getIssueById', data, {...config});
};


export { getIssuesByProperty, getIssueById };
